module.exports = "/assets/data/28fb5a436c406c6184350ae92311ac28-IP24.data.json";